module.exports = __webpack_public_path__ + "media/images/hand_logo-08dd6d3c488e82d0c4f543a128f0f1a4.png";